export default __webpack_public_path__ + "static/IIT VPU d1-496b3a15ecfb43a1bdc1c5858a6a9613.png";